var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"attach-wrapper"},[_c('input',{staticClass:"dropify",attrs:{"type":"file","id":"input-file-now","data-max-file-size":"1.4M"},on:{"change":_vm.fileAttached}})])
}
var staticRenderFns = []

export { render, staticRenderFns }